import React from "react";
import classes from "./AccountLimit.module.css";

import { useNavigate } from "react-router-dom";
// import { Field, Form, Formik } from 'formik';
// import { LoginFormInitialValues, LoginFormValidation } from '../../validations/LoginFormValidation';
import { useForm, Controller } from "react-hook-form";
import { Box, Grid, TextField } from "@mui/material";
import { useContext, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import styled from "styled-components";
import { Button } from "@mui/base";
import { RemoveRedEye } from "@mui/icons-material";

// import { useForm, Controller } from 'react-hook-form';
import Input from "@mui/material/Input"; // Assuming you're using Material-UI Input
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import TextFieldForm from "../../../../../components/common/textFieldForm";
import SweetAlertPopup from "../../../../../components/common/sweetAlertPopup";
import { postApiData } from "../../../../../components/utilities/nodeApiServices";
import { apiList } from "../../../../../components/utilities/nodeApiList";
import { errorMessages } from "../../../../../components/utilities/formValidation";
import AutocompleteForm from "../../../../../components/common/autuCompleteForm";
import RadioGroupForm from "../../../../../components/common/RedioButtonForm";
import Loader from "../../../../../components/common/loader";
import GoBackButton from "../../../../../components/common/GoBackButton";
import { useLanguage } from "../../../../../context/LanguageContext";

const defaultFormData = {
  accnumber: "",
  password: "",
  noofcheckbook: "",
  ifsccode: "",
  nickname: "",
  fullname: "",
  mobilenum: "",
  tpin: "",
  deliveryday: "",
  chequeNo: ""
};

const ChequeStatus = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [bene, setBene] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [userId, setUserId] = useState("");
  const [isLoading, setIsloading] = useState(false);


  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    register,
    watch,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: defaultFormData,
    mode: "onChange",
  });
  const navigate = useNavigate();
  const handlleNavigate = (route) => {
    navigate(route);
  };
  const { loading, error, isAuthenticated, user } = useSelector(
    (state) => state.auth
  );
  const popupAlert = (message, msgtype, msgicon) => {
    {
      Swal.fire({
        title: msgtype,
        text: message,
        icon: msgicon,
      });
    }
  };

  useEffect(() => {
    // Bene();
  }, []);

  const Bene = async (data) => {
    const payload = {
      custNo: user?.userId,
      sessionId: user?.sessionId,
    };
    setIsloading(true)
    const response = await postApiData(apiList.BENEFICIARYBROWSE, payload);
    // console.log("responseBene", response);
    if (response?.status == true) {
      setBene(response?.data.beneficiary);
      setIsloading(false)
    }
  };

  const { t } = useLanguage();
  const onSubmit = async (data) => {
    const payload = {
      custNo: user?.userId,
      sessionId: user?.sessionId,
      accNo: data.accno1.value,
      chequeNo: data.chequeNo,
    };

    setIsloading(true);

    const response = await postApiData(apiList.CHEQUEBOOKSTATUS, payload);

    // if (response?.status === true) {
    //   const chequeData = response?.data || {};

    //   const getValue = (val) => (val !== null && val !== undefined && val !== "" ? val : "-");

    //   const message =
    //     `Cheque Status Details : \n` +
    //     `Cheque No: ${getValue(chequeData.chequeNo)}\n` +
    //     `Cheque Date: ${getValue(chequeData.chequeDate)}\n` +
    //     `Payee Name: ${getValue(chequeData.chequePayeeName)}\n` +
    //     `Amount: ${getValue(chequeData.chequeAmount)}`;
    //   // `Cheque Status: ${getValue(chequeData.chequeStatusDesc)}`;

    //   SweetAlertPopup(message, "Success", "success");

    //   reset();
    // } 

    if (response?.status === true) {
      const chequeData = response?.data || {};

      // Helper to check valid (non-empty, non-null, non-undefined)
      const isValid = (val) => val !== null && val !== undefined && val !== "";

      let message = "Cheque Status Details:\n";

      if (isValid(chequeData.chequeNo)) {
        message += `Cheque No: ${chequeData.chequeNo}\n`;
      }

      if (isValid(chequeData.chequeDate)) {
        message += `Cheque Date: ${chequeData.chequeDate}\n`;
      }
      if (isValid(chequeData.chequeStatusDesc)) {
        message += `Cheque Status: ${chequeData.chequeStatusDesc}\n`;
      }
      if (isValid(chequeData.chequePayeeName)) {
        message += `Payee Name: ${chequeData.chequePayeeName}\n`;
      }

      if (isValid(chequeData.chequeAmount)) {
        message += `Amount: ${chequeData.chequeAmount}\n`;
      }

      // Uncomment below if you want to include cheque status
      // if (isValid(chequeData.chequeStatusDesc)) {
      //   message += `Cheque Status: ${chequeData.chequeStatusDesc}\n`;
      // }

      SweetAlertPopup(message.trim(), "Success", "success");

      reset();
    } else {
      SweetAlertPopup(response?.message || "Something went wrong", "Error", "error");
    }

    setIsloading(false);
  };

  const ColorButton1 = styled(Button)(({ theme }) => ({
    color: "#FFFFFF",
    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "var(--button-color)",
    border: "1px solid #CCC",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "133px",
    height: "31px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
  }));
  const ColorButton2 = styled(Button)(({ theme }) => ({
    color: "#707070",

    // backgroundColor: "#F84B67",
    // backgroundColor: "#323232",
    background: "#FFF",
    border: "1px solid #707070",
    borderRadius: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
    width: "133px",
    height: "31px",
    "&:hover": {
      background: "var(--button-hover-color)",
      color: "white",
    },
  }));

  const accountList =
    user?.accountDetails &&
    user?.accountDetails?.map((item) => ({
      code: item.brCode,
      value: item.accNo,
    }));

  return (
    <>
      {isLoading ? <Loader loading={true} /> : <Loader loading={false} />}
      <div className={classes.redrow}>
        <div>
          <div style={{ display: "flex", gap: '5px' }}>
            <GoBackButton />
            <div className={classes.SubHeading}>
              {t("cheque_StatusHeading")}
            </div>
          </div>
        </div>



      </div>
      <div className={classes.sbox}>
        <div className={classes.Payment1MobilePrepaidMainPage}>

          <div>


            <Box
              className={classes.box1}
              component="form"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className={classes.firsttabinfo}>
                <Grid
                  container
                  columnSpacing={4}
                  rowSpacing={2}
                  style={{ padding: "0.1vw" }}
                >
                  <Grid item xs={12} sm={12} md={3}>
                    <div className={classes.frowdataaff}>
                      <div className={classes.frowtextaff}>
                        {t("accountNumberLabel")}
                        <sup className={classes.required}>*</sup>
                      </div>
                      <div className={classes.widthtfield}>
                        <AutocompleteForm
                          controlerProps={{
                            control: control,
                            name: "accno1",
                          }}
                          TextFieldProps={{
                            style: { width: "100%" },

                            placeholder: t("accountNumberLabel"),
                            onKeyDown: (event) => {
                              //const regex = /^[a-zA-Z]*$/;
                              // const regex = /^[0-9]*$/;
                              const regex = /^[a-zA-Z0-9]*$/;
                              const isBackspace = event.keyCode === 8;
                              const isValidInput = regex.test(event.key);
                              const currentInputValue = event.target.value;
                              const maxLength = 32;
                              const isMaxLengthReached = currentInputValue.length >= maxLength;
                              if ((!isValidInput && !isBackspace) || (isMaxLengthReached && !isBackspace)) {
                                event.preventDefault();
                              }
                            },
                          }}
                          rules={{
                            required:
                              t("account_required")
                            // maxLength: {
                            //   value: 32, // Set your max length here
                            //   message: "Account Number must be no more than 10 digits long",
                            // },
                          }}
                          data={accountList}
                          required={true}
                        />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3}>
                    <div className={classes.frowdataaff}>
                      <div className={classes.frowtextaff}>
                        {t("cheque_no")}
                        <sup className={classes.required}>*</sup>
                      </div>
                      <div className={classes.widthtfield}>
                        <TextFieldForm
                          controlerProps={{
                            control: control,
                            name: "chequeNo",
                            rows: 5,
                            maxRows: 10,
                          }}
                          TextFieldProps={{
                            // label: "Branch",
                            placeholder: t("cheque_no"),
                            //   style: { width: "130%" },
                            fullWidth: true,
                            inputProps: { maxLength: 6 }
                          }}
                          // backgroundColor={true}
                          regExp={/^[0-9]+$/}
                          rules={{
                            required:
                              t("cheque_noRequired")
                          }}
                          required={true}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <div className={classes.payment1mobileprepaidbutton}>
                      <ColorButton2 onClick={() => { reset() }}>
                        {t("buttonReset")}
                      </ColorButton2>
                      <ColorButton1 variant="contained" type="submit">
                        {t("buttonSubmit")}
                      </ColorButton1>
                    </div>
                  </Grid>
                </Grid>
              </div>


            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChequeStatus;
